import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { formatDataBeforeView } from '../../../helpers/GeneralHelper';

export const ClientView = ({module, showModal, setShowModal, data}) => {

  const inputFields = {
    client_name: 'Client Name',
    client_domain: 'Domain / LOB',
    client_msa_status: 'MSA Status',
    client_size: 'Size',
    client_revenue: 'Revenue',
    client_presence: 'Presence',
    client_is_msp: 'Is MSP?',
    client_msp_name: 'MSP Name',
    client_is_vms_tool_used: 'VMS Tool Used',
    client_link: 'VMS Link',
    client_login_username: 'VMS Username',
    client_login_password: 'VMS Password',
    client_website: 'Website',
    state_name: 'Billing State',
    client_address: 'Address',
    client_remarks: 'Remarks',
    client_update_time: 'Updated At',
    client_create_time: 'Created At',
  }
  const formatOptions = [
    {
      'type': 'yesNo',
      'column': 'client_is_msp',
    },
    {
      'type': 'yesNo',
      'column': 'client_is_vms_tool_used',
    },
    {
      'type': 'datetime',
      'column': 'client_update_time',
    },
    {
      'type': 'datetime',
      'column': 'client_create_time',
    },
  ];

  const [fields, setFields] = useState(inputFields);
  useEffect(() => {
    if (data) {
      setFields(formatDataBeforeView(data, formatOptions));
    }
  }, [data]);

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} size='lg'>
      <Modal.Header closeButton>
          <Modal.Title>View {module.singularTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table className="table table-bordered table-hover table-sm">
          <tbody>
            {Object.keys(inputFields).map((item) => 
              <tr key={item}>
                <td>{inputFields[item]}</td>
                <th>{fields[item]}</th>
              </tr>
            )}
          </tbody>
        </table>
      </Modal.Body>
    </Modal>
  );
};
